<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>门店管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="门店ID"
                        prop="marketid">
            <el-input placeholder="请输入商场ID"
                      v-model="search.marketid"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="门店名称"
                        prop="marketname">
            <el-input placeholder="请输入门店名称"
                      v-model="search.marketname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="更新时间"
                        prop="updated_at">
            <el-date-picker
              v-model="search.updated_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="省份"
                        prop="provinceid">
            <el-select v-model="search.provinceid"
                       filterable
                       placeholder="请选择"
                       @visible-change="onGetProvince"
                       @change="onChangeProvince"
                       clearable>
              <el-option
                v-for="item in provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市"
                        prop="cityid">
            <el-select v-model="search.cityid"
                       filterable
                       placeholder="请选择"
                       @visible-change="onGetCities"
                       @change="onChangeCity"
                       clearable>
              <el-option
                v-for="item in cities"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区"
                        prop="areaid">
            <el-select v-model="search.areaid"
                       filterable
                       placeholder="请选择"
                       @visible-change="onGetAreaes"
                       clearable>
              <el-option
                v-for="item in areaes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status"
                       placeholder="请选择">
              <el-option
                v-for="item in statusOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       size="mini"
                       native-type="submit">搜索
            </el-button>
            <el-button @click="resetSearch"
                       size="mini">重置
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-tooltip class="item"
                    effect="dark"
                    content="导出"
                    placement="top">
          <el-button type="primary"
                     size="small"
                     icon="sj-icon-export"
                     @click="onExport()"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="刷新"
                    placement="top">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-refresh"
                     @click="onRefresh()"></el-button>
        </el-tooltip>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="marketid"
                         label="门店ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"></el-table-column>
        <el-table-column prop="province-city-area"
                         label="省市区">
          <template slot-scope="scope">
            {{scope.row.provincename}} -
            {{scope.row.cityname}} -
            {{scope.row.areaname}}
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         :formatter="formatStatus"
                         label="门店状态">
        </el-table-column>
        <el-table-column prop="orderid"
                         label="工单ID"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <router-link :to="'/market-ng/detail/' + scope.row.marketid">
              <el-button size="small">查看</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import marketMixins from '../../market/market.mixins'

export default {
  mixins: [table, marketMixins],
  computed: {
    ...Vuex.mapState('marketNg', {
      statusOpts: state => state.options.status,
    })
  },
  data () {
    return {
      table: [],
      provinces: [],
      cities: [],
      areaes: [],
      search: {
        marketid: this.$router.marketid,
        marketname: this.$router.name,
        updated_at: this.$router.updated_at,
        provinceid: this.$router.provinceid,
        cityid: this.$router.cityid,
        areaid: this.$router.areaid,
        status: this.$router.status * 1 || null,
      }
    }
  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      // 存在id获取省市区列表信息
      if (params.provinceid) {
        this.onGetProvince()
      }
      if (params.cityid) {
        this.onGetCities(true)
      }
      if (params.areaid) {
        this.onGetAreaes(true)
      }
      return request.common('queryMarketNg', params)
    },
    onExport () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        total: this.pagination.total,
        request: (params) => request('exportMarketNg', params),
        requestParams: this.search,
        type: 'array',
        getResponseData (data) {
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    formatStatus (row, column, cellValue, index) {
      for (let i in this.statusOpts) {
        if (this.statusOpts[i].value === cellValue * 1) {
          return this.statusOpts[i].label
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/market-ng/pages/MarketNgTable.vue